import { render, staticRenderFns } from "./SttConfigurations.vue?vue&type=template&id=5f1fa7b4&scoped=true&"
import script from "./SttConfigurations.vue?vue&type=script&lang=js&"
export * from "./SttConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./SttConfigurations.vue?vue&type=style&index=0&id=5f1fa7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1fa7b4",
  null
  
)

export default component.exports